import { useState } from 'react';
import Pill from '../common/Pill.jsx';
export default function FAQAccordion() {
  const [openQuestion, setOpenQuestion] = useState(null);
const faqData = [
  {
    id: 1,
    category: "Creating & Managing Agents",
    questions: [
      {
        id: 1,
        title: "Do I need technical skills or coding knowledge?",
        content:
          "None at all. If you can send an email or upload a file, you can build an AgoraVoice Agent. Our dashboard is designed for non-technical creators. You simply name your agent, give it a personality description, and upload your knowledge files. We handle the rest."
      },
      {
        id: 2,
        title: "How does the agent know what to say?",
        content:
          "You control the brain of the agent. You upload Knowledge Base documents—such as PDFs that contain relevant information (e.g., menus, guides, schedules, or manuals). The agent references only this information to answer questions, ensuring accuracy and preventing hallucinations."
      },
      {
        id: 3,
        title: "Can I update the information after I print the QR code?",
        content:
          "Yes! The QR code is dynamic. If your menu or exhibit changes, you simply upload a new document in your dashboard. The agent updates instantly—no need to reprint the QR code."
      },
      {
        id: 4,
        title: "What kind of data do I get back from the agents?",
        content:
          "Through our Owners Portal, you can see what customers are asking. We provide analytics on conversation volume, peak times, and summaries of the questions. This helps you understand interests and common questions."
      }
    ]
  },
  {
    id: 2,
    category: "The End User Experience",
    questions: [
      {
        id: 1,
        title: "Do my customers need to download an app to use this?",
        content:
          "No. Users simply scan the QR code using their phone camera, and the Voice Agent opens instantly in the mobile browser. No app, no login."
      },
      {
        id: 2,
        title: "What languages does the Voice Agent speak?",
        content:
          "AgoraVoice AI supports 20+ languages. If a user speaks French, the agent automatically replies in French. Language detection is automatic."
      },
      {
        id: 3,
        title: "Does the conversation feel natural? Can I interrupt the agent?",
        content:
          "Yes. Advanced VAD (Voice Activity Detection) allows you to interrupt the agent at any time. Just start talking—no need to wait for it to finish responding."
      },
      {
        id: 4,
        title: "Does it work in noisy environments like restaurants?",
        content:
          "Yes. Our audio processing focuses on the speaker's voice. It works well in busy environments like restaurants, galleries, and retail stores.",
      }
    ]
  },
  {
    id: 3,
    category: "Business, Privacy & Integration",
    questions: [
      {
        id: 1,
        title: "How much does it cost?",
        content:
          "We offer tiered pricing, from a Free Tier to enterprise solutions. Paid plans include more agents and advanced analytics. See our Pricing page for full details."
      },
      {
        id: 2,
        title: "Is my proprietary data secure?",
        content:
          "Yes. All documents are stored securely and used only for your agents. We do not train our public models on your private data."
      },
      {
        id: 3,
        title: "Can the agent perform tasks, like booking a table?",
        content:
          "Yes, on higher-tier plans. AgoraVoice AI integrates with external APIs and systems, enabling actions like table booking, lead capture, or creating support tickets."
      },
      {
        id: 4,
        title: "What happens if the agent doesn't know the answer?",
        content:
          "You can configure the fallback message, such as politely redirecting the user. These missed questions appear in your analytics so you can add the answer later."
      }
    ]
  }
];


  const toggleQuestion = (categoryId, questionId) => {
    const key = `${categoryId}-${questionId}`;
    setOpenQuestion(openQuestion === key ? null : key);
  };

  return (
    <div className="bg-amber-50 py-20">
      <div className="max-w-6xl mx-auto px-6">

         <div className="text-center flex flex-col items-center gap-4 mb-10">
            <Pill text="The future is voice" backgroundColor="#FFECEC" />
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2">
              FAQs
            </h2>
        
          </div>
        {faqData.map((category) => (
          <div key={category.id} className="mb-8">
            <h2 className="text-gray-900 font-bold mb-4 text-2xl px-2">
              {category.category}
            </h2>
            
            <div className="space-y-2">
              {category.questions.map((question) => {
                const questionKey = `${category.id}-${question.id}`;
                const isOpen = openQuestion === questionKey;

                return (
                  <div key={question.id} className="bg-white rounded-2xl shadow-sm overflow-hidden">
                    <button
                      onClick={() => toggleQuestion(category.id, question.id)}
                      className="w-full px-6 py-4 flex items-center justify-between text-left"
                    >
                      <span className="font-semibold">
                        {question.title}
                      </span>
                      {isOpen ? (
                        <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                        </svg>
                      ) : (
                        <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      )}
                    </button>

                    <div
                      className={`transition-all duration-300 ease-in-out overflow-hidden ${
                        isOpen ? 'max-h-96' : 'max-h-0'
                      }`}
                    >
                      <div className="px-6 pb-4  leading-relaxed whitespace-pre-line  pt-4">
                        {question.content}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
